/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SortDirection } from '../../models/sort-direction';
import { StationsPricePagedList } from '../../models/stations-price-paged-list';

export interface SearchStationsPrices$Any$Params {

/**
 * The list items offset
 */
  offset?: number;

/**
 * The list items limit
 */
  limit?: number;

/**
 * The start date time of data to filter
 */
  startDateTime?: string;

/**
 * The end date time of data to filter
 */
  endDateTime?: string;

/**
 * Indicates the field to use for sorting the data:
 *   * STATION_NAME : the station's name
 *   * CREATION_DATE : the creation's date
 *   * APPLICATION_DATE : the application's date
 *   * STATE : the request's state
 *   * HYDROGEN_PRICE : the energy's price
 *   * GNL_PRICE : the energy's price
 *   * GNC_PRICE : the energy's price
 *   * GNCL_PRICE : the energy's price
 *   * BIOGNC_PRICE : the energy's price
 */
  sortFieldName?: 'STATION_NAME' | 'STATION_CODE' | 'CREATION_DATE' | 'APPLICATION_DATE' | 'STATE' | 'HYDROGEN_PRICE' | 'GNL_PRICE' | 'GNC_PRICE' | 'GNCL_PRICE' | 'BIOGNC_PRICE';

/**
 * Sort direction : ASC, DESC
 */
  sortDirection?: SortDirection & any;
  
    /**
     * Body for search station's energie's prices
     */
    body?: any
}

export function searchStationsPrices$Any(http: HttpClient, rootUrl: string, params?: SearchStationsPrices$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<StationsPricePagedList>> {
  const rb = new RequestBuilder(rootUrl, searchStationsPrices$Any.PATH, 'post');
  if (params) {
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('startDateTime', params.startDateTime, {});
    rb.query('endDateTime', params.endDateTime, {});
    rb.query('sortFieldName', params.sortFieldName, {});
    rb.query('sortDirection', params.sortDirection, {});
    rb.body(params.body, 'application/octet-stream');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<StationsPricePagedList>;
    })
  );
}

searchStationsPrices$Any.PATH = '/custom/stations/request-update-price/search';
